var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import AreaOfStudyService from "../../../../Services/AreaOfStudy.service";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import DateService from "../../../../Services/Shared/Date.service";
import { getAreaOfStudyDetailPath } from "./AreaOfStudyRoutes";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import SearchField from "../../../Form/SearchField";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import SelectField from "../../../Form/SelectField";
import { AreaOfStudyTypeMultiSearch } from "../../../Presentational/AreaOfStudyType/AreaOfStudyType";
import NumberService from "../../../../Services/Shared/Number.service";
const PAGE_SIZE = 50;
const AreaOfStudyListTable = () => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({});
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No area of study found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return AreaOfStudyService.search({
                query: sArgs.query,
                active: sArgs.active,
                areaOfStudyTypeIds: sArgs.areaOfStudyTypeIds,
            }, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "ID",
                sortId: "AREA_OF_STUDY_ID",
                size: 0.3,
            },
            {
                title: "Name",
                sortId: "AREA_OF_STUDY_NAME",
            },
            {
                title: "Code",
                sortId: "AREA_OF_STUDY_CODE",
            },
            {
                title: "Active",
                sortId: "AREA_OF_STUDY_ACTIVE",
                align: "center",
                size: 0.4,
            },
            {
                title: "Type",
                sortId: "AREA_OF_STUDY_TYPE",
                size: 0.6,
            },
            {
                title: "Sis Modification Date",
                sortId: "AREA_OF_STUDY_SIS_MODIFIED_DATE",
                size: 0.8,
            },
            {
                title: "Sis Import Date",
                sortId: "AREA_OF_STUDY_SIS_CREATED_DATE",
                size: 0.8,
            },
        ],
        rows: ({ data }) => data.map((areaOfStudy, index) => {
            return [
                areaOfStudy.id,
                _jsx(Link, { to: getAreaOfStudyDetailPath(areaOfStudy.id), children: areaOfStudy.name }, index),
                areaOfStudy.code,
                _jsx(BooleanDisplay, { val: areaOfStudy.active }, index),
                areaOfStudy.areaOfStudyType.name,
                DateService.displayLongWithTimeWithoutWeekday(areaOfStudy.sisImportModifiedDate),
                DateService.displayLongWithTimeWithoutWeekday(areaOfStudy.sisImportCreatedDate),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "mb-3", children: ["Area Of Study", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total)
                        ? `(${NumberService.format((_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total)})`
                        : ""] }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        var _c, _d;
                        let active;
                        switch ((_c = formState.active) === null || _c === void 0 ? void 0 : _c.value) {
                            case "active":
                                active = true;
                                break;
                            case "inactive":
                                active = false;
                                break;
                            default:
                                active = undefined;
                        }
                        setSearchArgs({
                            query: formState.query,
                            active,
                            areaOfStudyTypeIds: (_d = formState.areaOfStudyTypes) === null || _d === void 0 ? void 0 : _d.map((osc) => osc.id),
                        });
                    }), children: [_jsx(TextField, { name: "query", label: "Search name" }), _jsx(SelectField, { label: "Status", name: "active", options: [
                                {
                                    label: "Active",
                                    value: "active",
                                },
                                {
                                    label: "Inactive",
                                    value: "inactive",
                                },
                            ] }), _jsx(SearchField, { label: "Type", name: "areaOfStudyTypes", as: (provided) => _jsx(AreaOfStudyTypeMultiSearch, Object.assign({}, provided)) })] }) }), _jsx("div", { className: "py-2", children: table })] }));
};
const AreaOfStudyList = () => {
    return (_jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(AreaOfStudyListTable, {}) }));
};
export default AreaOfStudyList;
